// package: notificationmanager
// file: notification-manager.proto

var notification_manager_pb = require("./notification-manager_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var NotificationManager = (function () {
  function NotificationManager() {}
  NotificationManager.serviceName = "notificationmanager.NotificationManager";
  return NotificationManager;
}());

NotificationManager.GetIntegrationStatus = {
  methodName: "GetIntegrationStatus",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.IntegrationStatusReq,
  responseType: notification_manager_pb.IntegrationStatusReply
};

NotificationManager.InstallIntegration = {
  methodName: "InstallIntegration",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.InstallIntegrationReq,
  responseType: notification_manager_pb.InstallIntegrationReply
};

NotificationManager.AddConfig = {
  methodName: "AddConfig",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.NotificationConfig,
  responseType: notification_manager_pb.AddConfigReply
};

NotificationManager.EditConfig = {
  methodName: "EditConfig",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.EditConfigReq,
  responseType: notification_manager_pb.EditConfigReply
};

NotificationManager.GetConfig = {
  methodName: "GetConfig",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.ConfigReq,
  responseType: notification_manager_pb.UserConfigResp
};

NotificationManager.GetConfigDetails = {
  methodName: "GetConfigDetails",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.ConfigDetailsReq,
  responseType: notification_manager_pb.ConfigDetailsReply
};

NotificationManager.DeleteConfig = {
  methodName: "DeleteConfig",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.DeleteConfigReq,
  responseType: notification_manager_pb.DeleteConfigReply
};

NotificationManager.EditAccountMeta = {
  methodName: "EditAccountMeta",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.AccountMetaReq,
  responseType: notification_manager_pb.EditAccountMetaReply
};

NotificationManager.EditConfigStatus = {
  methodName: "EditConfigStatus",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.EditConfigStatusReq,
  responseType: notification_manager_pb.EditConfigStatusReply
};

NotificationManager.AddBot = {
  methodName: "AddBot",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.AddBotReq,
  responseType: notification_manager_pb.AddBotReply
};

NotificationManager.EditBot = {
  methodName: "EditBot",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.EditBotReq,
  responseType: notification_manager_pb.EditBotReply
};

NotificationManager.GetBots = {
  methodName: "GetBots",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.GetBotsReq,
  responseType: notification_manager_pb.GetBotsReply
};

NotificationManager.EditBotStatus = {
  methodName: "EditBotStatus",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.EditBotStatusReq,
  responseType: notification_manager_pb.EditBotStatusReply
};

NotificationManager.DeleteBots = {
  methodName: "DeleteBots",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.DeleteBotReq,
  responseType: notification_manager_pb.DeleteBotReply
};

NotificationManager.AddChannel = {
  methodName: "AddChannel",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.AddChannelReq,
  responseType: notification_manager_pb.AddChannelReply
};

NotificationManager.EditChannel = {
  methodName: "EditChannel",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.EditChannelReq,
  responseType: notification_manager_pb.EditChannelReply
};

NotificationManager.GetChannel = {
  methodName: "GetChannel",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.GetChannelReq,
  responseType: notification_manager_pb.GetChannelReply
};

NotificationManager.EditChannelStatus = {
  methodName: "EditChannelStatus",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.EditChannelStatusReq,
  responseType: notification_manager_pb.EditChannelStatusReply
};

NotificationManager.DeleteChannel = {
  methodName: "DeleteChannel",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.DeleteChannelReq,
  responseType: notification_manager_pb.DeleteChannelReply
};

NotificationManager.GetBotEventConfigs = {
  methodName: "GetBotEventConfigs",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.GetBotEventConfigsReq,
  responseType: notification_manager_pb.GetBotEventConfigsReply
};

NotificationManager.GetBotEventDetails = {
  methodName: "GetBotEventDetails",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.GetBotEventDetailsReq,
  responseType: notification_manager_pb.GetBotEventDetailsReply
};

NotificationManager.EditBotEventDetails = {
  methodName: "EditBotEventDetails",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.EditBotEventDetailsReq,
  responseType: notification_manager_pb.EditBotEventDetailsReply
};

NotificationManager.EditBotEventStatus = {
  methodName: "EditBotEventStatus",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.EditBotEventStatusReq,
  responseType: notification_manager_pb.EditBotEventStatusReply
};

NotificationManager.UninstallIntegration = {
  methodName: "UninstallIntegration",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.UninstallIntegrationReq,
  responseType: notification_manager_pb.UninstallIntegrationReply
};

NotificationManager.GetDefaultNotifications = {
  methodName: "GetDefaultNotifications",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.GetDefaultNotificationsReq,
  responseType: notification_manager_pb.GetDefaultNotificationsReply
};

NotificationManager.GetNotifications = {
  methodName: "GetNotifications",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.GetNotificationsReq,
  responseType: notification_manager_pb.GetNotificationsReply
};

NotificationManager.GetNotification = {
  methodName: "GetNotification",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.GetNotificationReq,
  responseType: notification_manager_pb.GetNotificationReply
};

NotificationManager.EnableNotification = {
  methodName: "EnableNotification",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.EnableNotificationReq,
  responseType: notification_manager_pb.EnableNotificationReply
};

NotificationManager.DisableNotification = {
  methodName: "DisableNotification",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.DisableNotificationReq,
  responseType: notification_manager_pb.DisableNotificationReply
};

NotificationManager.OverrideNotification = {
  methodName: "OverrideNotification",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.OverrideNotificationReq,
  responseType: notification_manager_pb.OverrideNotificationReply
};

NotificationManager.UnblockAccount = {
  methodName: "UnblockAccount",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.UnblockNotificationReq,
  responseType: notification_manager_pb.UnblockNotificationReply
};

NotificationManager.BlockAccount = {
  methodName: "BlockAccount",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.BlockNotificationReq,
  responseType: notification_manager_pb.BlockNotificationReply
};

NotificationManager.GetAccountPermissions = {
  methodName: "GetAccountPermissions",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.GetAccountPermissionsReq,
  responseType: notification_manager_pb.GetAccountPermissionsReply
};

NotificationManager.AddAccount = {
  methodName: "AddAccount",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.AccountMetaReq,
  responseType: notification_manager_pb.AddAccountReply
};

NotificationManager.EditAccount = {
  methodName: "EditAccount",
  service: NotificationManager,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.AccountMetaReq,
  responseType: notification_manager_pb.EditAccountReply
};

exports.NotificationManager = NotificationManager;

function NotificationManagerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

NotificationManagerClient.prototype.getIntegrationStatus = function getIntegrationStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetIntegrationStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.installIntegration = function installIntegration(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.InstallIntegration, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.addConfig = function addConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.AddConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editConfig = function editConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getConfig = function getConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getConfigDetails = function getConfigDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetConfigDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.deleteConfig = function deleteConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.DeleteConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editAccountMeta = function editAccountMeta(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditAccountMeta, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editConfigStatus = function editConfigStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditConfigStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.addBot = function addBot(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.AddBot, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editBot = function editBot(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditBot, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getBots = function getBots(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetBots, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editBotStatus = function editBotStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditBotStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.deleteBots = function deleteBots(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.DeleteBots, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.addChannel = function addChannel(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.AddChannel, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editChannel = function editChannel(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditChannel, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getChannel = function getChannel(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetChannel, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editChannelStatus = function editChannelStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditChannelStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.deleteChannel = function deleteChannel(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.DeleteChannel, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getBotEventConfigs = function getBotEventConfigs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetBotEventConfigs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getBotEventDetails = function getBotEventDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetBotEventDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editBotEventDetails = function editBotEventDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditBotEventDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editBotEventStatus = function editBotEventStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditBotEventStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.uninstallIntegration = function uninstallIntegration(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.UninstallIntegration, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getDefaultNotifications = function getDefaultNotifications(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetDefaultNotifications, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getNotifications = function getNotifications(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetNotifications, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getNotification = function getNotification(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetNotification, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.enableNotification = function enableNotification(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EnableNotification, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.disableNotification = function disableNotification(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.DisableNotification, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.overrideNotification = function overrideNotification(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.OverrideNotification, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.unblockAccount = function unblockAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.UnblockAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.blockAccount = function blockAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.BlockAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.getAccountPermissions = function getAccountPermissions(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.GetAccountPermissions, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.addAccount = function addAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.AddAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NotificationManagerClient.prototype.editAccount = function editAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NotificationManager.EditAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.NotificationManagerClient = NotificationManagerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "notificationmanager.Internal";
  return Internal;
}());

Internal.IntSendNotification = {
  methodName: "IntSendNotification",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.NotificationReq,
  responseType: notification_manager_pb.IntSendNotificationReply
};

Internal.IntAddUserConfig = {
  methodName: "IntAddUserConfig",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.UserMetaReq,
  responseType: notification_manager_pb.IntAddUserConfigReply
};

Internal.IntUpdateUserConfig = {
  methodName: "IntUpdateUserConfig",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.IntUpdateUserConfigReq,
  responseType: notification_manager_pb.IntUpdateUserConfigReply
};

Internal.IntAddAccountConfig = {
  methodName: "IntAddAccountConfig",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.UserMetaReq,
  responseType: notification_manager_pb.IntAddAccountConfigReply
};

Internal.IntDeleteAccountConfig = {
  methodName: "IntDeleteAccountConfig",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: notification_manager_pb.IntDeleteAccountConfigReq,
  responseType: notification_manager_pb.IntDeleteAccountConfigReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.intSendNotification = function intSendNotification(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSendNotification, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intAddUserConfig = function intAddUserConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntAddUserConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpdateUserConfig = function intUpdateUserConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpdateUserConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intAddAccountConfig = function intAddAccountConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntAddAccountConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intDeleteAccountConfig = function intDeleteAccountConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntDeleteAccountConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

